import { useTranslation } from "react-i18next"
import { Pie, PieChart } from "recharts"

import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart"
import type { DashboardSmaugTypeEnum } from "@/enums"
import { useDashboardSmaug } from "@/hooks"
import { cn } from "@/lib/utils"
type DashboardBrandRecurringChartProps = {
  dashboardType: DashboardSmaugTypeEnum
  searchParams?: SearchParamsType
}
export const DashboardBrandRecurringChart: React.FC<
  DashboardBrandRecurringChartProps
> = ({ dashboardType, searchParams }) => {
  const { t } = useTranslation()
  const { data: mostUsedBrand } = useDashboardSmaug({
    dashboardType,
    ...searchParams,
  })
  const getBrandInfo = (indicator: string) => {
    switch (indicator) {
      case "VISA":
        return {
          fill: "hsl(var(--chart-1))",
          bg: "before:bg-chart-1",
        }
      case "MASTERCARD":
        return {
          fill: "hsl(var(--chart-2))",
          bg: "before:bg-chart-2",
        }
      default:
        return {
          fill: "hsl(var(--chart-3))",
          bg: "before:bg-chart-3",
        }
    }
  }
  const chartData = mostUsedBrand?.indicator?.map(
    (indicator) => ({
      key: indicator.key,
      value: +indicator.value.replace("%", ""),
      fill: getBrandInfo(indicator.key).fill,
    })
  )

  if (!chartData || chartData.length === 0) {
    return (
      <div className="flex min-h-[200px] items-center justify-center text-sm text-muted-foreground">
        {t("pages.dashboard.noDataAvailable")}
      </div>
    )
  }

  return (
    <div>
      <ChartContainer
        config={{}}
        className="mx-auto aspect-square max-h-[200px]"
      >
        <PieChart>
          <ChartTooltip
            cursor={false}
            content={<ChartTooltipContent hideLabel />}
          />
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="key"
            innerRadius={50}
          />
        </PieChart>
      </ChartContainer>
      <ul className="space-y-2">
        {chartData?.map((indicator) => (
          <li
            key={indicator.key}
            className="group flex items-center justify-between text-sm"
            data-approved={indicator.key === "Aprovado"}
          >
            <span
              className={cn(
                "before:mr-1 before:inline-block before:size-2 before:rounded",
                getBrandInfo(indicator.key).bg
              )}
            >
              {indicator.key}
            </span>
            <span>{indicator.value}%</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
